<template>
  <div class="attribution">
    Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. 
    Coded by <a href="#">Daniel Bennett</a>.
  </div>
</template>

<script>
export default {
  name: "Attribution",
};
</script>

<style lang="scss" scoped>
  .attribution {
    text-align: center;
  }
</style>